import {
    CREATE_TICKET,
} from "./types";

import TicketService from "../services/TicketService";

export const createTicket = (data, sessionId = null) => async (dispatch) => {
    try {
        const ticketData = sessionId ? { ...data, session_id: sessionId } : data;

        const res = await TicketService.create(ticketData);
        dispatch({
            type: CREATE_TICKET,
            payload: res.data,
        });
        return res;
    } catch (err) {
        console.error("Error creating ticket:", err);
        throw err;
    }
};
